module.exports = __webpack_public_path__ + "img/icon-5.b57be594.png";